// extracted by mini-css-extract-plugin
module.exports = {"container":"TopStandards_container__xSPh7","title":"TopStandards_title__9_ljz"};